import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { ExpandableButton } from './ExpandableButton';
import { ExpandableButtonUnified } from './ExpandableButtonUnified';
const ExpandableWrap = styled.div `
  display: flex;
  flex-direction: column;
`;
export const ExpandableContainer = styled.div `
  &.open {
    max-height: ${(props) => String(props.maxHeight)}px;
  }

  max-height: 0;
  order: ${(props) => (props.buttonPosition === 'top' ? '1' : '0')};
  overflow: hidden;
  transition-duration: ${(props) => props.transitionDuration}ms;
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.66, 0.26, 0.08, 0.76);
  &.closed [aria-label],
  &.closed button {
    visibility: hidden;
  }
`;
export const ExpandableElement = ({ children, isInitiallyOpened = false, buttonPosition = 'top', transitionDuration: transitionDurationInitValue, i18n, onClick, isPdp, }) => {
    const [isExpanded, setExpanded] = useState(isInitiallyOpened);
    const [maxHeight, setMaxHeight] = useState(0);
    const transitionDurationFallback = (maxHeight / 100) * 250;
    const [transitionDuration, setTransitionDuration] = useState(transitionDurationInitValue || transitionDurationFallback);
    const expandableRef = React.useRef(null);
    React.useEffect(() => {
        if (expandableRef.current) {
            setMaxHeight(expandableRef.current.offsetHeight);
        }
    }, [isExpanded]);
    React.useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            setTransitionDuration(0);
            setMaxHeight(entries[0].contentBoxSize[0].blockSize);
        });
        if (expandableRef.current) {
            observer.observe(expandableRef.current);
        }
        return () => {
            observer.unobserve(expandableRef.current);
        };
    }, [expandableRef.current]);
    const onExpandHandler = () => {
        if (onClick) {
            onClick();
        }
        setTransitionDuration(transitionDurationInitValue || transitionDurationFallback);
        setExpanded(!isExpanded);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ExpandableWrap, null,
            isPdp ? (React.createElement(ExpandableButtonUnified, { isExpanded: isExpanded, onExpandHandler: onExpandHandler, i18n: i18n })) : (React.createElement(ExpandableButton, { isExpanded: isExpanded, onExpandHandler: onExpandHandler, buttonPosition: buttonPosition, i18n: i18n })),
            React.createElement(ExpandableContainer, { className: isExpanded ? 'open' : 'closed', buttonPosition: buttonPosition, maxHeight: maxHeight, transitionDuration: transitionDuration, "data-testid": "expandableContainer", "aria-hidden": isExpanded ? undefined : 'true', tabIndex: isExpanded ? undefined : -1 },
                React.createElement("div", { className: "expandableInner", ref: expandableRef }, children)))));
};
